import React from "react";

import "./Card.scss";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
}

export default function Card({ children, className, ...props }: IProps) {
    const classNames = ["userful-card noselect", className].filter(Boolean).join(" ");

    return (
        <div className={classNames} {...props}>
            {children}
        </div>
    );
}
